module.exports = __webpack_public_path__ + "static/news1-cd810aacbbb5aed8a893d49b53c2b2ab.png";